<template>
  <svg
    width="96"
    height="64"
    viewBox="0 0 96 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M69.0754 36.071H27.0154V80.8059H69.0754V36.071Z"
      fill="url(#paint0_linear_13_462)"
    />
    <path
      d="M26.9854 39.1377H18.0154V77.5473H26.9854V39.1377Z"
      fill="url(#paint1_linear_13_462)"
    />
    <path
      d="M26.9854 39.1377H18.0154V77.5473H26.9854V39.1377Z"
      fill="url(#paint2_linear_13_462)"
    />
    <path
      d="M43.9651 39.1377H34.9951V77.5473H43.9651V39.1377Z"
      fill="url(#paint3_linear_13_462)"
    />
    <path
      d="M43.9651 39.1377H34.9951V77.5473H43.9651V39.1377Z"
      fill="url(#paint4_linear_13_462)"
    />
    <path
      d="M60.9452 39.1377H51.9752V77.5473H60.9452V39.1377Z"
      fill="url(#paint5_linear_13_462)"
    />
    <path
      d="M60.9452 39.1377H51.9752V77.5473H60.9452V39.1377Z"
      fill="url(#paint6_linear_13_462)"
    />
    <path
      d="M77.9253 39.1377H68.9553V77.5473H77.9253V39.1377Z"
      fill="url(#paint7_linear_13_462)"
    />
    <path
      d="M77.9253 39.1377H68.9553V77.5473H77.9253V39.1377Z"
      fill="url(#paint8_linear_13_462)"
    />
    <path
      d="M30.0151 36.6761H15.045V38.0399C15.045 39.3899 16.125 40.4699 17.475 40.4699H27.5851C28.9351 40.4699 30.0151 39.3899 30.0151 38.0399V36.6761Z"
      fill="url(#paint9_radial_13_462)"
    />
    <path
      d="M30.0151 36.6761H15.045V38.0399C15.045 39.3899 16.125 40.4699 17.475 40.4699H27.5851C28.9351 40.4699 30.0151 39.3899 30.0151 38.0399V36.6761Z"
      fill="url(#paint10_linear_13_462)"
    />
    <path
      d="M30.0151 36.6761H15.045V38.0399C15.045 39.3899 16.125 40.4699 17.475 40.4699H27.5851C28.9351 40.4699 30.0151 39.3899 30.0151 38.0399V36.6761Z"
      fill="url(#paint11_linear_13_462)"
    />
    <path
      d="M46.9651 36.6036L31.9951 36.6035V38.0395C31.9951 39.3895 33.0751 40.4695 34.4251 40.4695H44.5351C45.8851 40.4695 46.9651 39.3895 46.9651 38.0395V36.6036Z"
      fill="url(#paint12_radial_13_462)"
    />
    <path
      d="M46.9651 36.6036L31.9951 36.6035V38.0395C31.9951 39.3895 33.0751 40.4695 34.4251 40.4695H44.5351C45.8851 40.4695 46.9651 39.3895 46.9651 38.0395V36.6036Z"
      fill="url(#paint13_linear_13_462)"
    />
    <path
      d="M46.9651 36.6036L31.9951 36.6035V38.0395C31.9951 39.3895 33.0751 40.4695 34.4251 40.4695H44.5351C45.8851 40.4695 46.9651 39.3895 46.9651 38.0395V36.6036Z"
      fill="url(#paint14_linear_13_462)"
    />
    <path
      d="M63.9752 36.7141L49.0053 36.7142L49.0052 38.0401C49.0052 39.3901 50.0852 40.4701 51.4352 40.4701H61.5452C62.8952 40.4701 63.9752 39.3901 63.9752 38.0401V36.7141Z"
      fill="url(#paint15_radial_13_462)"
    />
    <path
      d="M63.9752 36.7141L49.0053 36.7142L49.0052 38.0401C49.0052 39.3901 50.0852 40.4701 51.4352 40.4701H61.5452C62.8952 40.4701 63.9752 39.3901 63.9752 38.0401V36.7141Z"
      fill="url(#paint16_linear_13_462)"
    />
    <path
      d="M63.9752 36.7141L49.0053 36.7142L49.0052 38.0401C49.0052 39.3901 50.0852 40.4701 51.4352 40.4701H61.5452C62.8952 40.4701 63.9752 39.3901 63.9752 38.0401V36.7141Z"
      fill="url(#paint17_linear_13_462)"
    />
    <path
      d="M80.9553 36.7185H65.9854V38.0402C65.9854 39.3902 67.0653 40.4702 68.4153 40.4702H78.5253C79.8753 40.4702 80.9553 39.3902 80.9553 38.0402V36.7185Z"
      fill="url(#paint18_radial_13_462)"
    />
    <path
      d="M80.9553 36.7185H65.9854V38.0402C65.9854 39.3902 67.0653 40.4702 68.4153 40.4702H78.5253C79.8753 40.4702 80.9553 39.3902 80.9553 38.0402V36.7185Z"
      fill="url(#paint19_linear_13_462)"
    />
    <path
      d="M80.9553 36.7185H65.9854V38.0402C65.9854 39.3902 67.0653 40.4702 68.4153 40.4702H78.5253C79.8753 40.4702 80.9553 39.3902 80.9553 38.0402V36.7185Z"
      fill="url(#paint20_linear_13_462)"
    />
    <path
      d="M12.1051 29.8198H83.9851V35.5802C83.9851 36.6302 83.1451 37.4702 82.0951 37.4702H13.9951C12.9451 37.4702 12.1051 36.6302 12.1051 35.5802V31.4702V29.8198Z"
      fill="#B8B1C0"
    />
    <path
      d="M12.1051 29.8198H83.9851V35.5802C83.9851 36.6302 83.1451 37.4702 82.0951 37.4702H13.9951C12.9451 37.4702 12.1051 36.6302 12.1051 35.5802V31.4702V29.8198Z"
      fill="url(#paint21_linear_13_462)"
    />
    <path
      d="M12.1051 29.8198H83.9851V35.5802C83.9851 36.6302 83.1451 37.4702 82.0951 37.4702H13.9951C12.9451 37.4702 12.1051 36.6302 12.1051 35.5802V31.4702V29.8198Z"
      fill="url(#paint22_linear_13_462)"
    />
    <path
      d="M12.1051 29.8198H83.9851V35.5802C83.9851 36.6302 83.1451 37.4702 82.0951 37.4702H13.9951C12.9451 37.4702 12.1051 36.6302 12.1051 35.5802V31.4702V29.8198Z"
      fill="url(#paint23_linear_13_462)"
    />
    <path
      d="M45.9784 9.03023L10.0985 29.2502C9.01847 29.8502 9.43846 31.5302 10.6985 31.5302H85.3385C86.5985 31.5302 87.0185 29.8802 85.9385 29.2502L50.0584 9.03023C48.7984 8.31023 47.2384 8.31023 45.9784 9.03023Z"
      fill="url(#paint24_linear_13_462)"
    />
    <path
      d="M45.9784 9.03023L10.0985 29.2502C9.01847 29.8502 9.43846 31.5302 10.6985 31.5302H85.3385C86.5985 31.5302 87.0185 29.8802 85.9385 29.2502L50.0584 9.03023C48.7984 8.31023 47.2384 8.31023 45.9784 9.03023Z"
      fill="url(#paint25_linear_13_462)"
    />
    <path
      d="M45.9784 9.03023L10.0985 29.2502C9.01847 29.8502 9.43846 31.5302 10.6985 31.5302H85.3385C86.5985 31.5302 87.0185 29.8802 85.9385 29.2502L50.0584 9.03023C48.7984 8.31023 47.2384 8.31023 45.9784 9.03023Z"
      fill="url(#paint26_linear_13_462)"
    />
    <path
      d="M45.9784 9.03023L10.0985 29.2502C9.01847 29.8502 9.43846 31.5302 10.6985 31.5302H85.3385C86.5985 31.5302 87.0185 29.8802 85.9385 29.2502L50.0584 9.03023C48.7984 8.31023 47.2384 8.31023 45.9784 9.03023Z"
      fill="url(#paint27_linear_13_462)"
    />
    <path
      d="M86.3252 29.01L48.7652 7.68C48.5252 7.56 48.2852 7.5 48.0152 7.5C47.7752 7.5 47.5052 7.56 47.2652 7.68L9.70516 29.01C9.04516 29.4 8.80516 30.21 9.19516 30.87C9.46516 31.29 9.91514 31.53 10.3951 31.53C10.6351 31.53 10.8752 31.47 11.1152 31.35L47.3252 10.8C47.7452 10.56 48.2852 10.56 48.7052 10.8L84.9152 31.35C85.1252 31.47 85.3951 31.53 85.6351 31.53C86.1151 31.53 86.5952 31.29 86.8352 30.87C87.2252 30.21 87.0152 29.37 86.3252 29.01Z"
      fill="url(#paint28_linear_13_462)"
    />
    <path
      d="M86.3252 29.01L48.7652 7.68C48.5252 7.56 48.2852 7.5 48.0152 7.5C47.7752 7.5 47.5052 7.56 47.2652 7.68L9.70516 29.01C9.04516 29.4 8.80516 30.21 9.19516 30.87C9.46516 31.29 9.91514 31.53 10.3951 31.53C10.6351 31.53 10.8752 31.47 11.1152 31.35L47.3252 10.8C47.7452 10.56 48.2852 10.56 48.7052 10.8L84.9152 31.35C85.1252 31.47 85.3951 31.53 85.6351 31.53C86.1151 31.53 86.5952 31.29 86.8352 30.87C87.2252 30.21 87.0152 29.37 86.3252 29.01Z"
      fill="url(#paint29_linear_13_462)"
    />
    <path
      d="M86.3252 29.01L48.7652 7.68C48.5252 7.56 48.2852 7.5 48.0152 7.5C47.7752 7.5 47.5052 7.56 47.2652 7.68L9.70516 29.01C9.04516 29.4 8.80516 30.21 9.19516 30.87C9.46516 31.29 9.91514 31.53 10.3951 31.53C10.6351 31.53 10.8752 31.47 11.1152 31.35L47.3252 10.8C47.7452 10.56 48.2852 10.56 48.7052 10.8L84.9152 31.35C85.1252 31.47 85.3951 31.53 85.6351 31.53C86.1151 31.53 86.5952 31.29 86.8352 30.87C87.2252 30.21 87.0152 29.37 86.3252 29.01Z"
      fill="url(#paint30_linear_13_462)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_13_462"
        x1="49.5083"
        y1="33.4998"
        x2="49.5083"
        y2="80.8059"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#35303B" />
        <stop
          offset="1"
          stop-color="#65527A"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_13_462"
        x1="18.0184"
        y1="58.3466"
        x2="28.2973"
        y2="58.3466"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#817C86" />
        <stop
          offset="0.572917"
          stop-color="#CFC7D7"
        />
        <stop
          offset="0.67166"
          stop-color="#CFC7D7"
        />
        <stop
          offset="1"
          stop-color="#9A94A1"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_13_462"
        x1="22.5004"
        y1="38.372"
        x2="22.5004"
        y2="42.0482"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.390359"
          stop-color="#71677D"
        />
        <stop
          offset="1"
          stop-color="#71677D"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_13_462"
        x1="34.9981"
        y1="58.3466"
        x2="45.277"
        y2="58.3466"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7B7681" />
        <stop
          offset="0.572917"
          stop-color="#BFB9C8"
        />
        <stop
          offset="0.67166"
          stop-color="#BFB9C8"
        />
        <stop
          offset="1"
          stop-color="#B2ABB8"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_13_462"
        x1="39.4801"
        y1="38.372"
        x2="39.4801"
        y2="42.0482"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.390359"
          stop-color="#71677D"
        />
        <stop
          offset="1"
          stop-color="#71677D"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_13_462"
        x1="51.9782"
        y1="58.3466"
        x2="62.2572"
        y2="58.3466"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6E6A73" />
        <stop
          offset="0.572917"
          stop-color="#CBC3D3"
        />
        <stop
          offset="0.67166"
          stop-color="#CBC3D3"
        />
        <stop
          offset="1"
          stop-color="#BFB9C5"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_13_462"
        x1="56.4602"
        y1="38.372"
        x2="56.4602"
        y2="42.0482"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.390359"
          stop-color="#71677D"
        />
        <stop
          offset="1"
          stop-color="#71677D"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint7_linear_13_462"
        x1="68.9583"
        y1="58.3466"
        x2="79.2373"
        y2="58.3466"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#615E6A" />
        <stop
          offset="0.572917"
          stop-color="#DAD2E2"
        />
        <stop
          offset="0.67166"
          stop-color="#DCD4E4"
        />
        <stop
          offset="1"
          stop-color="#D5CDDC"
        />
      </linearGradient>
      <linearGradient
        id="paint8_linear_13_462"
        x1="73.4403"
        y1="38.372"
        x2="73.4403"
        y2="42.0482"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.390359"
          stop-color="#71677D"
        />
        <stop
          offset="1"
          stop-color="#71677D"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint9_radial_13_462"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(26.3898 38.9793) rotate(180) scale(9.73563 2.81099)"
      >
        <stop stop-color="#91899D" />
        <stop
          offset="1"
          stop-color="#6D6976"
        />
      </radialGradient>
      <linearGradient
        id="paint10_linear_13_462"
        x1="22.5301"
        y1="36.5406"
        x2="22.5301"
        y2="38.2814"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop
          offset="1"
          stop-color="#564F5E"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint11_linear_13_462"
        x1="22.5301"
        y1="41.3117"
        x2="22.5301"
        y2="39.8933"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop
          offset="1"
          stop-color="#564F5E"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint12_radial_13_462"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.3398 38.9789) rotate(180) scale(9.7356 2.81099)"
      >
        <stop stop-color="#91899D" />
        <stop
          offset="1"
          stop-color="#6D6976"
        />
      </radialGradient>
      <linearGradient
        id="paint13_linear_13_462"
        x1="39.4801"
        y1="36.5402"
        x2="39.4801"
        y2="38.281"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop
          offset="1"
          stop-color="#564F5E"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint14_linear_13_462"
        x1="39.4801"
        y1="41.3113"
        x2="39.4801"
        y2="39.8929"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop
          offset="1"
          stop-color="#564F5E"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint15_radial_13_462"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(60.3499 38.9795) rotate(180) scale(9.7356 2.81099)"
      >
        <stop stop-color="#91899D" />
        <stop
          offset="1"
          stop-color="#6D6976"
        />
      </radialGradient>
      <linearGradient
        id="paint16_linear_13_462"
        x1="56.4902"
        y1="36.5408"
        x2="56.4902"
        y2="38.2816"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop
          offset="1"
          stop-color="#564F5E"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint17_linear_13_462"
        x1="56.4902"
        y1="41.3119"
        x2="56.4902"
        y2="39.8935"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop
          offset="1"
          stop-color="#564F5E"
          stop-opacity="0"
        />
      </linearGradient>
      <radialGradient
        id="paint18_radial_13_462"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(77.33 38.9795) rotate(180) scale(9.7356 2.81099)"
      >
        <stop stop-color="#91899D" />
        <stop
          offset="1"
          stop-color="#6D6976"
        />
      </radialGradient>
      <linearGradient
        id="paint19_linear_13_462"
        x1="73.4703"
        y1="36.5408"
        x2="73.4703"
        y2="38.2816"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop
          offset="1"
          stop-color="#564F5E"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint20_linear_13_462"
        x1="73.4703"
        y1="41.3119"
        x2="73.4703"
        y2="39.8935"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#564F5E" />
        <stop
          offset="1"
          stop-color="#564F5E"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint21_linear_13_462"
        x1="83.9851"
        y1="37.4701"
        x2="82.0754"
        y2="37.4701"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E8DFEF" />
        <stop
          offset="1"
          stop-color="#E8DFEF"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint22_linear_13_462"
        x1="48.0451"
        y1="38.1983"
        x2="48.0451"
        y2="35.6952"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#726483" />
        <stop
          offset="1"
          stop-color="#726483"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint23_linear_13_462"
        x1="11.6565"
        y1="37.4702"
        x2="14.2815"
        y2="37.4702"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#706D76" />
        <stop
          offset="1"
          stop-color="#706D76"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint24_linear_13_462"
        x1="59.613"
        y1="13.155"
        x2="48.0185"
        y2="33.2175"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3ACBB" />
        <stop
          offset="1"
          stop-color="#ACA5B2"
        />
      </linearGradient>
      <linearGradient
        id="paint25_linear_13_462"
        x1="61.3474"
        y1="17.5612"
        x2="60.2692"
        y2="19.4362"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#645A6F" />
        <stop
          offset="1"
          stop-color="#645A6F"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint26_linear_13_462"
        x1="48.0185"
        y1="33.19"
        x2="48.0185"
        y2="31.0854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#878190" />
        <stop
          offset="1"
          stop-color="#878190"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint27_linear_13_462"
        x1="35.6097"
        y1="16.5939"
        x2="36.219"
        y2="17.6721"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.344727"
          stop-color="#857F8E"
        />
        <stop
          offset="1"
          stop-color="#857F8E"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint28_linear_13_462"
        x1="79.1417"
        y1="25.5995"
        x2="13.6543"
        y2="25.5995"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#ADA7B8" />
        <stop
          offset="1"
          stop-color="#9F99A4"
        />
      </linearGradient>
      <linearGradient
        id="paint29_linear_13_462"
        x1="59.5064"
        y1="13.2863"
        x2="51.5591"
        y2="27.2719"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A9A3B1" />
        <stop
          offset="0.0965298"
          stop-color="#CFC6D6"
          stop-opacity="0.85"
        />
        <stop
          offset="0.176002"
          stop-color="#857D92"
        />
        <stop
          offset="0.248998"
          stop-color="#857D92"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint30_linear_13_462"
        x1="41.7162"
        y1="10.1415"
        x2="51.5591"
        y2="27.2719"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#908B98" />
        <stop
          offset="0.0960017"
          stop-color="#A9A3B0"
        />
        <stop
          offset="0.115282"
          stop-color="#A9A3B0"
        />
        <stop
          offset="0.287107"
          stop-color="#C8BFD0"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
